export default __webpack_public_path__ + "partner_121cc8f9.png";